import { render, staticRenderFns } from "./redConstruction.vue?vue&type=template&id=e209f122&scoped=true"
import script from "./redConstruction.vue?vue&type=script&lang=js"
export * from "./redConstruction.vue?vue&type=script&lang=js"
import style0 from "./redConstruction.vue?vue&type=style&index=0&id=e209f122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e209f122",
  null
  
)

export default component.exports